import type { HelpDoc } from "./HelpDoc";

// 매뉴얼에 없는 챗봇 전용 Q&A. 형식은 HelpDoc과 동일
// - id: " > " 없이 고유하게 (챗봇 버튼/검색 단위)
// - keywords: 사용자가 칠 법한 단어. "검사데이터"처럼 붙여 써도 됨(공백 무시 비교)
// - summary: 한 줄 답, blocks.body: 상세 설명 (최대 5줄 노출)
// - related: 이어서 보여줄 버튼 (매뉴얼 id도 가능)
export const faqDocs: HelpDoc[] = [
  {
    id: "검사 데이터 분리",
    title: "검사 데이터는 어떻게 분리되나요?",
    keywords: ["검사데이터", "데이터분리", "분리", "저장위치"],
    // TODO: 실제 동작 기준으로 답변 작성
    summary: "검사 데이터가 분리되어 저장되는 방식에 대한 안내입니다.",
    blocks: [
      {
        body: [
          `검사 데이터는 이미지 유형에 따라 Train과 Valid로 구성됩니다.
        - OK·Annotation 이미지 → 주로 Train
        - NG·상세 라벨 분류 이미지 → Valid
        ※ 데이터 구성에 대한 상세 기준은 검사 프로젝트 페이지 상단 안내에서 확인할 수 있습니다.`,
        ],
      },
    ],
    related: [{ id: "검사관리", title: "검사관리", summary: "" }],
  },
];
